import { popoverAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { textStyles, colors, shadows, } from "../../../../theme/foundations/generated";
import { transformBoxShadowToDropShadow } from "../../../helpers";
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = {
    content: Object.assign({ borderRadius: 0, width: "auto", maxWidth: "25rem", minHeight: "4rem", backgroundColor: "semantic.foreground.primary", color: "semantic.text.inverse", filter: `drop-shadow(${transformBoxShadowToDropShadow(shadows.large)})` }, textStyles.body.smallMedium),
    body: {
        display: "flex",
        padding: "1rem",
        minHeight: "4rem",
    },
    arrow: {
        backgroundColor: `${colors.semantic.foreground.primary} !important`,
    },
};
const PopoverTheme = defineMultiStyleConfig({
    baseStyle,
});
export default PopoverTheme;
//# sourceMappingURL=Popover.default.js.map